import { createContext } from "react";
import { ConfigInterface } from "./types";

export const WithQueryConfigContext = createContext<ConfigInterface>({});
